import type { JSX } from 'react'
import type { IControlsProps } from '../Controls'

import {
  ControlBackwardSecondaryOpacityDarkVerticalFluid,
  ControlForwardSecondaryOpacityDarkVerticalFluid,
} from 'atoms/Button/Templates'
import { Fluid, JustifyContent } from '../Controls.h'
import { ContainerControls } from '../index'

/**
 * Controls appears on Container hover or if pagination step is available
 * Controls cannot be disabled
 */

export type IFluidControlsTemplateProps = Omit<IControlsProps, 'children'>

export const FluidControlsTemplate = ({
  controlsState = [
    {
      visible: true,
      disabled: true,
    },
    {
      visible: true,
      disabled: false,
    },
  ],
  justifyContent = JustifyContent.SpaceBetween,
  fluid = Fluid.Both,
  ...rest
}: IFluidControlsTemplateProps): JSX.Element => (
  <ContainerControls
    controlsState={controlsState}
    justifyContent={justifyContent}
    fluid={fluid}
    {...rest}
  >
    <ControlBackwardSecondaryOpacityDarkVerticalFluid />
    <ControlForwardSecondaryOpacityDarkVerticalFluid />
  </ContainerControls>
)
